export const positionCssMapper = {
  center: 'center',
  start: 'flex-start',
  end: 'flex-end'
}
